export const instructionsSteps = ['address_for_courier', 'messemger_for_contact', 'nickname_or_phone_number'];
